import type { IconName } from "@similarweb/icons";
import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";
import type { Translatable } from "app/pages/sales-intelligence/types";
import { StyledPanelIcon, StyledPanelTitleWithIcon, StyledTitle } from "./styles";

type Props = {
    iconName: IconName;
    title: Readonly<Translatable>;
};

function PanelTitleWithIcon(props: Props) {
    const { iconName, title } = props;

    return (
        <StyledPanelTitleWithIcon alignItems="center">
            <StyledPanelIcon
                iconName={iconName}
                size="xs"
            />
            <I18n
                data-automation="actions-panel.label-text"
                element={StyledTitle}
                translatable={title}
            />
        </StyledPanelTitleWithIcon>
    );
}

export default PanelTitleWithIcon;
